<template>
	<div>
    <section class="content-header">
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> &nbsp; </a></li>
      </ol>
    </section>
    <section class="content">
        <div class="row" id="defaultImg">
          <img src="../../../static/img/banner.png">
        </div>
    </section>
  </div>
</template>
<style scoped>
.row{ text-align: center;line-height: 500px; }
#defaultImg img{ max-width: 100%;}

</style>
<script>
import $ from 'jquery'
let _p = global.xwCommon, pageTitle = ""

export default {
  	name: 'changelog',
    data: () => { 
      return { pageTitle,  } 
    },
  	mounted(){

      $(window).resize(function () { //监听浏览器窗口变化事件
          let height=(document.documentElement.clientHeight-220);
          $("#defaultImg").css("line-height",height+"px")

      });
  		_p.setTitle(pageTitle)

  	}
};
</script>


// WEBPACK FOOTER //
// defaultPage.vue?961ed548